<template lang="pug">
.generic-wrapper
  .container
    h1.title Stammdaten
    .sub-headline Fügen Sie neue Objekte hinzu oder verändern Sie bestehende.

    MenuItems
      MenuItem(name="Mietobjekte" description="Erstellen Sie neue oder verändern Sie bestehende Mietobjekte." @click="$router.push({name: 'DataRentObjects'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z')
            polyline(points='9 22 9 12 15 12 15 22')
      MenuItem(name="Gäste" description="Verwalten Sie Gästedaten."  @click="$router.push({name: 'DataCustomers'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2')
            circle(cx='9' cy='7' r='4')
            path(d='M23 21v-2a4 4 0 0 0-3-3.87')
            path(d='M16 3.13a4 4 0 0 1 0 7.75')
      MenuItem(name="Eigentümer" description="Verwalten Sie Eigentümerdaten und -zugänge."  @click="$router.push({name: 'DataOwners'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2')
            circle(cx='9' cy='7' r='4')
            path(d='M23 21v-2a4 4 0 0 0-3-3.87')
            path(d='M16 3.13a4 4 0 0 1 0 7.75')
      MenuItem(name="Reinigungsfirmen" description="Verwalten Sie Reinigungsfirmen."  @click="$router.push({name: 'DataCleaners'})")
        template(v-slot:img)
          svg(xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewbox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round')
            path(d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2')
            circle(cx='9' cy='7' r='4')
            path(d='M23 21v-2a4 4 0 0 0-3-3.87')
            path(d='M16 3.13a4 4 0 0 1 0 7.75')
</template>

<script>
import MenuItem from "@/components/atoms/MenuItem.vue";
import MenuItems from "@/components/molecules/MenuItems.vue";

export default {
    components: {
        MenuItem,
        MenuItems
    }
}
</script>